export default __webpack_public_path__ + "static/media/photos.7fd82125.png";